import { TabType } from "@/common/stores/persistingStores/navigation";
import { Flex } from "../flex";
import { Text, tokens } from "@fluentui/react-components";
import { useTabTitle } from "@/hooks/navigationTabs";

export const TabHeader = (props: {
	tab: TabType;
	noBottomPadding?: boolean;
}) => {
	const getTitle = useTabTitle();

	return (
		<Flex
			style={{
				padding: props.noBottomPadding
					? "16px 16px 0px 12px"
					: "16px 16px 10px 12px",
				color: tokens.colorNeutralForeground3,
			}}
		>
			<Text weight="bold">{getTitle(props.tab)}</Text>
		</Flex>
	);
};
